var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap"},[_c('ul',[_c('li',{staticClass:"li-page",on:{"click":_vm.goPrePage}},[_vm._v("上一页")]),_vm._l((_vm.showPageBtn),function(i,index){return _c('li',{key:index,class:{
        active: i === _vm.currentPage,
        pointer: i,
        hover: i && i !== _vm.currentPage,
      },on:{"click":function($event){return _vm.pageOffset(i)}}},[(i)?_c('a',[_vm._v(_vm._s(i))]):_c('a',[_vm._v("···")])])}),_c('li',{staticClass:"li-page",on:{"click":_vm.goNextPage}},[_vm._v("下一页")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }